import { requests } from '../index';
import URLS  from '../endPoints';
import request from 'superagent';

import axios from "axios"

let Home = {}

// magitt Billboard
Home.getSingleJob = async (JOBID) => await requests.get(URLS.magUrl.singlejob+JOBID) //api call
Home.getrelatedJob = async (payload) =>await requests.post(URLS.magUrl.realtedjob,payload) //api call
    
Home.getallSearchResult = async (payload) => {
   let res= await requests.post(URLS.magUrl.searchApi, payload)
}

Home.groups = async () => await requests.get(URLS.magUrl.groups)
Home.applicationSummary = async (JOBID) => await requests.getHC(URLS.hcUrl.applicationSummary+JOBID) //api call
Home.jobApply = async (payload) => await requests.postHC(URLS.hcUrl.jobApply,payload) //api call
Home.saveAppliedJobsHc=async (payload) => await requests.post(URLS.magUrl.saveAppliedJobsHc,payload) //api call
Home.saveRegisterDetails= async(payload) => await requests.post(URLS.magUrl.SaveDetails,payload)
export default Home;
